import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';

import { DocumentService } from '../../../services/documents/document.service';
import { NotyService } from '../../../services/common/noty.service';
import { SharesService } from '../../../services/shares/shares.service';
import { MatterStoreService } from '../../../services/matters/matter-store.service';
import { Matter } from '../../../models/matter';
@Component({
  selector: 'app-shares-new',
  templateUrl: './shares-new.component.html',
  styleUrls: ['./shares-new.component.scss'],
})
export class SharesNewComponent implements OnInit, OnDestroy {
  @Input() noRedirection: boolean = false;
  filteringDocs: boolean = false;
  formSubmitted: boolean = false;
  formSubmitting: boolean = false;
  loading: boolean = true;
  matterId: number | null;
  contacts: Array<any> = [];
  authors: Array<any> = [];
  selectedContacts: Array<any> = [];
  selectedContactIds: Array<any> = [];
  documents: Array<any> = [];
  media: Array<any> = [];
  mediaCount: number = 0;
  message: string;
  selectedFiles: Array<any> = [];
  selectAllDocs: boolean = false;
  docCount: number = 0;
  paginatedDocs: Array<any> = [];
  paginateParams: any = {
    page: 1,
    per_page: 10,
  };
  filterValues: any = {
    docAuthor: '',
    docFromDate: '',
    docToDate: '',
    docType: '',
    tags: ''
  };
  /**isChecked
   * Constructor
   * @param {ActivatedRoute} private route        Angular route object for current route
   */
  constructor(private documentService:    DocumentService, 
              private matterStoreService: MatterStoreService, 
              private notyService:        NotyService,
              private route:              ActivatedRoute, 
              private router:             Router,        
              private sharesService:      SharesService) {}

  ngOnInit(): void {
    this.reset();
  }

  componentDestroyed: boolean = false;

  ngOnDestroy(): void {
    this.componentDestroyed = true;
  }

  changeContactSelection(contact: any) {
    if(this.componentDestroyed) return;
    contact.isChecked = !contact.isChecked;
    this.fetchSelectedItems();
  }
  fetchSelectedItems() {
    console.log('Contact selection updated')
    this.selectedContacts = this.contacts.filter((value, index) => {
      return value.isChecked;
    });
  }
  fetchCheckedIDs() {
    this.selectedContactIds = [];
    this.contacts.forEach((value, index) => {
      if (value.isChecked) {
        this.selectedContactIds.push(value.id);
      }
    });
  }
  shortenName(docName: string) {
    if (docName && docName.length > 20) {
      docName = docName.slice(0, 20) + '...';
      return docName;
    } else {
      return docName || 'Nil';
    }
  }
  dateFormatter(ISOdate: string | Date) {
    ISOdate = new Date(ISOdate);
    return ISOdate.getMonth() + 1 + '/' + ISOdate.getDate() + '/' + ISOdate.getFullYear();
  }
  selectFile(file: any) {
    if(this.componentDestroyed) return;
    console.log("Selected file", file);
    if (this.selectedFiles.length > 0) {
      let filePresent: boolean = false;
      for (let selectedFile of this.selectedFiles) {
        if (file.id == selectedFile.id && file.media_type == selectedFile.media_type) {
          filePresent = true;
        }
      }
      if (!filePresent) {
        this.selectedFiles.push(file);
      }
    }
    if (this.selectedFiles.length === 0) {
      this.selectedFiles.push(file);
    }
  }
  removeFile(index: number) {
    this.selectedFiles.splice(index, 1);
  }
  loadDocs(pageEvent: any = null) {
    if(this.componentDestroyed || !this.matterId) return;
    if (pageEvent) this.paginateParams.page = pageEvent.page;
    let { page, per_page } = this.paginateParams;
    let { docAuthor, docFromDate, docToDate, docType, tags } = this.filterValues;
    this.documentService
      .filterSelect({ page, per_page, matter_id: this.matterId, author_id: docAuthor, date_from: docFromDate, date_to: docToDate, document_type_id: docType, tags: tags })
      .then((res) => {
        if(this.componentDestroyed) return;
        this.documents = res.documents;
        for(let doc of this.documents) {
          doc.shortName = this.shortenName(doc.name);
        }
        this.docCount = res.maxDocCount;
        this.filteringDocs = false;
      })
      .catch(() => {
        if(this.componentDestroyed) return;
        this.filteringDocs = false;
      });
  }
  loadMediaFiles(pageEvent: any = null) {
    if(this.componentDestroyed || !this.matterId) return;
    if (pageEvent) {
      this.paginateParams.page = pageEvent.page;
    }
    let { page, per_page } = this.paginateParams;
    this.sharesService
      .media({ page, per_page, matter_id: this.matterId })
      .then((res) => {
        if(this.componentDestroyed) return;
        this.media = res.media;
        this.mediaCount = res.maxMediaCount;
      })
      .catch(() => {
      });
  }
  filterDocs(filterDocsForm: NgForm) {
    if(this.componentDestroyed) return;
    this.filteringDocs = true;
    this.filterValues = {
      ...this.filterValues,
      ...filterDocsForm.form.value,
    };
    this.paginateParams.page = 1;
    this.loadDocs();
  }

  clearDocumentTypeFilter() {
    this.filterValues.docType = '';
  }
  makeFileShare() {
    if(this.componentDestroyed) return;
    this.formSubmitting = true;
    let selectedContactsEmails = [];
    let selectedFiles = [];
    for (let selectedContact of this.selectedContacts) {
      selectedContactsEmails.push(selectedContact.email_id);
    }
    if (!this.selectAllDocs) {
      for (let selectedFile of this.selectedFiles) {
        if (!selectedFile.media_type) selectedFiles.push(selectedFile.id);
      }
    }
    let mediaIds: Array<any> = [];
    for (let selectedFile of this.selectedFiles) {
      if (selectedFile.media_type) mediaIds.push(selectedFile.id);
    }
    console.log("File selection", selectedFiles, mediaIds);
    this.sharesService
      .create({ matter_id: this.matterId, email_address_ids: selectedContactsEmails, document_ids: selectedFiles, media_ids: mediaIds, message: this.message || '', all_documents: this.selectAllDocs ? '1' : ' ' })
      .then((response_json) => {
        if(this.componentDestroyed) return;
        this.formSubmitting = false;
        if (response_json.success) {
          this.notyService.notify('File Share Successful', 'success');
          this.matterStoreService.matterAdministrationComponent!.reindexSolr('histories');
          if (!this.noRedirection) {
            this.router.navigate([`/matters/${this.matterId}`]);
          }
        } else {
          this.notyService.notify(response_json.text || 'File Share failed', 'error');
        }
      })
      .catch((res) => {
        if(this.componentDestroyed) return;
        this.notyService.notify('File Share Error', 'error');
        this.formSubmitting = false;
      });
  }
  cancelFileShare() {
    if(this.componentDestroyed) return;
    this.router.navigate([`/matters/${this.matterId}`]);
  }
  reset() {
    if(this.componentDestroyed) return;
    this.formSubmitted      = false;
    this.formSubmitting     = false;
    this.loading            = true;
    this.matterId           = null;
    this.contacts           = [];
    this.authors            = [];
    this.selectedContacts   = [];
    this.selectedContactIds = [];
    this.documents          = [];
    this.media              = [];
    this.mediaCount         = 0;
    this.selectedFiles      = [];
    this.selectAllDocs      = false;
    this.docCount           = 0;
    this.paginatedDocs      = [];
    this.paginateParams = {
      page: 1,
      per_page: 10,
    };
    this.filterValues = {
      docAuthor: '',
      docFromDate: '',
      docToDate: '',
      docType: '',
    };
    this.fetchSelectedItems();
    this.fetchCheckedIDs();
    const matterId = Number(this.route.snapshot.params['matter_id'] || this.route.snapshot.params['id']);
    this.matterId = Number.isFinite(matterId) ? matterId : null;
    this.loadDocs();
    this.loadMediaFiles();
    if(!this.matterId) return;
    this.sharesService
      .formOptions(this.matterId)
      .then((response_json) => {
        if(this.componentDestroyed) return;
        this.loading = false;
        response_json.contacts.forEach((contact: any, index: number) => {
          contact.isChecked = false;
          contact.id = index;
        });
        this.contacts = response_json.contacts;
        this.authors  = response_json.authors;
      })
      .catch(() => {
        if(this.componentDestroyed) return;
      });
  }
}
